import RichTextBox from "components/richTextBox";
import { Typography, Grid } from "@material-ui/core";
import { useStyles } from '../style';

export default function Description(props) {
    const classes = useStyles();
    const { labDetails, bindGeneralInfo } = props;
    const description = labDetails && labDetails.description;
    return (
        <>
            <Grid item xs={6}>
                <Typography color="textPrimary" className={classes.subheader}>Description</Typography>
            </Grid>
            <RichTextBox
                content={description || ''}
                onChange={bindGeneralInfo}
                property='description'

            />
        </>
    )
}

